import { toSafeLowerString, toSafeString } from '@shared/utils';
import { NON_RUNNING_RUN_STATES } from '@/lib/pieveRunState.js';
import getInteractionEventId from '@/lib/threadInteractions/getInteractionEventId.js';
import getInteractionRunId from '@/lib/threadInteractions/getInteractionRunId.js';
import normalizePendingInteraction from '@/lib/threadInteractions/normalizePendingInteraction.js';
import toResolvedInteractionIdSet from '@/lib/threadInteractions/toResolvedInteractionIdSet.js';

const EMPTY_PENDING_INTERACTIONS = [];

const getPendingInteractionsFromActivity = ({ activity = [], runState = 'idle', activeRunId = null }) => {
  const normalizedActivity = Array.isArray(activity) ? activity : EMPTY_PENDING_INTERACTIONS;

  if (normalizedActivity.length < 1) {
    return EMPTY_PENDING_INTERACTIONS;
  }

  const normalizedRunState = toSafeLowerString(runState || 'idle');
  const normalizedActiveRunId = toSafeString(activeRunId);
  const resolvedInteractionIds = toResolvedInteractionIdSet(normalizedActivity);
  const pendingInteractions = normalizedActivity
    .filter((item) => {
      const normalizedType = toSafeLowerString(item?.type);

      if (normalizedType !== 'approval' && normalizedType !== 'interaction') {
        return false;
      }

      const interactionId = getInteractionEventId(item);

      if (!interactionId) {
        return false;
      }

      const interactionRunId = toSafeString(getInteractionRunId(item));

      if (normalizedActiveRunId && interactionRunId && interactionRunId !== normalizedActiveRunId) {
        return false;
      }

      if (normalizedActiveRunId && interactionRunId && interactionRunId === normalizedActiveRunId && NON_RUNNING_RUN_STATES.has(normalizedRunState)) {
        return false;
      }

      return !resolvedInteractionIds.has(interactionId);
    })
    .map((item) => {
      return normalizePendingInteraction(item);
    })
    .filter(Boolean);

  return pendingInteractions.length > 0 ? pendingInteractions : EMPTY_PENDING_INTERACTIONS;
};

export default getPendingInteractionsFromActivity;
